@if (callActions.length) {
  <div class="conference" data-test-id="scheduled-box-info-box">
    <div class="flex flex-col">
      @for (ca of callActions; track ca) {
        <div>
          <mat-icon
            class="call-select"
            [ngClass]="{ active: ca.callAction.expertActionId === activeCallAction?.callAction?.expertActionId }"
            [matTooltip]="ca.callAction.externalName"
            (click)="selectActiveAction(ca)"
          >
            event_note
          </mat-icon>
        </div>
      }
    </div>
    @if (activeCallAction) {
      <ng-container [ngTemplateOutlet]="callDetails"></ng-container>
      @for (reminder of activeCallAction.reminders; track reminder) {
        <app-scheduled-box-reminder
          [expert]="expert"
          [callAction]="activeCallAction.callAction"
          [conferenceReminder]="reminder"
        >
        </app-scheduled-box-reminder>
      }
      @if (showActionStatuses.includes(activeCallAction.callAction.status)) {
        <button
          mat-icon-button
          class="edit"
          data-test-id="scheduled-box-menu-elipsis"
          [routerLink]="['/admin', 'experts', expert.expertId]"
          [queryParams]="{ tab: 'Conferences' }"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      }
    }
  </div>
}

<ng-template #callDetails>
  <div class="meta-info-vertical flex justify-evenly content-stretch items-stretch flex-col">
    @if (activeCallAction?.callAction) {
      <div class="flex justify-between w-full flex-row gap-2.5 font-bold">
        <span class="conference-title" [title]="activeCallAction.callAction.internalName">{{
          activeCallAction.callAction.internalName
        }}</span>
        <span class="conference-title" [title]="activeCallAction.callAction.externalName">{{
          activeCallAction.callAction.externalName
        }}</span>
      </div>
      <span>{{ activeCallAction.callAction.datetime | date: 'medium' }}</span>
      @if (activeCallAction.callAction.joinMetadata?.weblink) {
        <a target="_blank" [href]="activeCallAction.callAction.joinMetadata.weblink">
          {{ activeCallAction.callAction.joinMetadata.weblink }}
        </a>
      }
      @if (!activeCallAction.callAction.joinMetadata?.weblink) {
        <span> No weblink found for this conference </span>
      }
      @if (activeCallAction.callAction.zoomMetadata?.zoomAccount) {
        <span> Zoom account: {{ activeCallAction.callAction.zoomMetadata.zoomAccount }} </span>
      }
      <span>{{ activeCallAction.callAction.isRecordingOn ? 'Recorded' : 'Not Recorded' }}</span>
    } @else {
      No active call action
    }
  </div>
</ng-template>
